import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 2.4rem 1.6rem;

  @media (min-width: 640px) {
    background: #fff;
    border-radius: 1.6rem;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    padding: 4rem;
    width: 100%;
    max-width: 420px;
  }
`;

export const Input = styled.input`
  background-color: #cacae4;
  border: 0.1rem solid #a8aabc;

  :focus {
    border: 0.1rem solid #a8aabc;
  }

  ::placeholder {
    color: #fff;
    opacity: 1;
  }

  text-decoration: none;
  color: #fff;
  font-size: 1.6rem;

  padding: 1.6rem;
  border-radius: 0.8rem;
`;
